export const apiUrls = {
  list: "/api/channels",
  fastAdd: "/api/channels/fast",
  setOrder: "/api/channels/setOrder",
  info: "/api/channels/channel_{channelId}",
  settings: "/api/channels/channel_{channelId}/settings",
  checkChannel: "/api/channels/check",
  messages: "/api/channels/channel_{channelId}/messages",
  tariffs: "/api/channels/channel_{channelId}/tariffs",
  getImage: "/api/channels/channel_{channelId}/image",
  generateMetaCover: "/api/channels/channel_{channelId}/createMetaCover",
  generateCover: "/api/channels/channel_{channelId}/createCover",
  generateStoryCover: "/api/channels/channel_{channelId}/createStoryCover",
  delete: "/api/channels/channel_{channelId}/delete",
  rejectCasts: "/api/channels/channel_{channelId}/rejectCasts",
  htmlParseMessages: "/api/channels/channel_{channelId}/htmlParse",
  scoreMessages: "/api/channels/channel_{channelId}/messages/scoreUnscored",
  fastAddMessages: "/api/channels/channel_{channelId}/messages/fastAdd",
  messageInfo: "/api/channels/channel_{channelId}/messages/message_{messageId}",
};

export const path = "/channels";

export const infoLink = (channel) => {
  return `${path}/channel_${channel._id}`;
};

export const formLink = (channel) => {
  return `${infoLink(channel)}/form`;
};
